window.addEventListener('load', cartPageInit);

function cartPageInit() {
  initMoreInfoLinks();

  initQuantitySelectors();

  initRemoveFromCartLinks();

  checkForOrphanUpsells();

  checkForLegacyItems();

  addUpsellKeysToLegacyEditUrls();

  // Updates images for Legacy Items, modified to skip non legacy items
  Customizer.getCustomizedImages({ location: 'cart' });
}

function initRemoveFromCartLinks() {
  const removeLinks = document.querySelectorAll('a.cart__item__remove__link');
  removeLinks.forEach(removeLink => {
    removeLink.addEventListener('click', async event => {
      event.preventDefault();
      const itemElement = removeLink.closest('[data-line-item]');
      const childLineItemElements = getChildLineItemElements(itemElement);

      if (childLineItemElements.length === 0) {
        await removeItemWithUpsells(itemElement);
        return;
      }

      const confirmed = confirm(
        'By removing this product any matching Add-On products will also be removed. Are you sure you want to remove this product from your cart? This cannot be undone.'
      );

      if (confirmed) await removeItemWithUpsells(itemElement);
    });
  });
}

function initQuantitySelectors() {
  const quantityInputs = document.querySelectorAll('input.quantity--input');
  quantityInputs.forEach(input =>
    input.addEventListener('change', event => {
      event.preventDefault();
      inputChangeListener();
    })
  );
}

function initMoreInfoLinks() {
  const moreInfoLinks = document.querySelectorAll('.js-more-info-link');
  moreInfoLinks.forEach(infoLink =>
    infoLink.addEventListener('click', event => {
      event.preventDefault();
      const { target: link } = event;
      toggleMoreInfo(link);
    })
  );
}

function inputChangeListener() {
  //find all hidden inputs and remove them from the form
  const allInputs = document.querySelectorAll(
    '#cart-form input[type="number"]'
  );
  allInputs.forEach(input => !input.offsetParent && input.remove());

  //then click the hidden update form button
  const hiddenUpdateButton = document.querySelector('button[name="update"]');
  hiddenUpdateButton.click();
}

function checkForOrphanUpsells() {
  const lineItemsWithParentCode = document.querySelectorAll(
    '.js-line-item-row[data-parent-code]:not([data-parent-code=""])'
  );

  const lineItemsWithMinimumOfTwo = document.querySelectorAll(
    '[data-is-orphan="true"]'
  );

  const lineItemsToCheck = new Set([
    ...lineItemsWithParentCode,
    ...lineItemsWithMinimumOfTwo
  ]);

  let totalQuantity = 0;
  const lineItemRows = document.querySelectorAll('.js-line-item-row');

  lineItemRows.forEach(lineItemRow => {
    const quantityInput = lineItemRow.querySelector('input.quantity--input');
    totalQuantity += parseInt(quantityInput.value, 10) || 0;
  });

  // If a single upsell is the only item in the cart then don't allow
  // the customer to checkout, and show a message explaining why.
  const upsellIsOnlyCartItem =
    lineItemsToCheck.size === 1 && totalQuantity === 1;

  const checkoutButton = document.getElementById('checkout');
  const orphanedMessage = document.getElementById('orphaned');

  if (upsellIsOnlyCartItem) {
    checkoutButton.setAttribute('disabled', 'disabled');
    orphanedMessage.style.display = 'block';
    return;
  }

  checkoutButton.removeAttribute('disabled');
  orphanedMessage.style.display = 'none';
}

function checkForLegacyItems() {
  const legacyItems = document.querySelectorAll(
    '.js-line-item-row[data-order-system="LEGACY"]'
  );

  if (legacyItems.length) {
    const checkout = document.getElementById('checkout');
    checkout.setAttribute('disabled', 'disabled');
    const legacyMessage = document.getElementById('legacy-items-in-cart');
    legacyMessage.style.display = 'block';
  }
}

function getChildLineItemElements(itemElement) {
  const legacyProductCode = itemElement.getAttribute('data-product-code');
  return legacyProductCode
    ? document.querySelectorAll(
        `.js-line-item-row[data-parent-code="${legacyProductCode}"]`
      )
    : [];
}

function getChildLineItemKeys(itemElement) {
  const childLineItemElements = getChildLineItemElements(itemElement);
  return Array.from(childLineItemElements).map(childLineItemElement =>
    childLineItemElement.getAttribute('data-line-item-key')
  );
}

async function removeItemWithUpsells(itemElement) {
  const lineItemKey = itemElement.getAttribute('data-line-item-key');
  const childLineItemKeys = getChildLineItemKeys(itemElement);

  const updates = {};

  childLineItemKeys.forEach(
    childLineItemKey => (updates[childLineItemKey] = 0)
  );

  updates[lineItemKey] = 0;

  await updateCartQuantities(updates);
  window.location.reload();
}

function toggleMoreInfo(linkElement) {
  const id = linkElement.getAttribute('data-id');
  const infoSectionElement = document.querySelector(
    `.js-more-info-text[data-id="${id}"]`
  );

  const isOpen = infoSectionElement.classList.contains('open');
  if (isOpen) {
    infoSectionElement.classList.remove('open');
    linkElement.innerHTML = '+ more info';
    return;
  }

  infoSectionElement.classList.add('open');
  linkElement.innerHTML = '- less info';
}

function updateCartQuantities(updates) {
  return (updatedCartQuantities = fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  }));
}

function centsToDollars(cents) {
  return (cents / 100).toFixed(2);
}

function getParentLineItemElements() {
  const allLineItemElements = document.querySelectorAll('.js-line-item-row');
  const nonUpsellLineItems = Array.from(allLineItemElements).filter(item => {
    const parentCode = item.getAttribute('data-parent-code');
    return !parentCode;
  });
  return nonUpsellLineItems;
}

function getAllParentLegacyLineItemElements() {
  const lineItemElements = getParentLineItemElements();
  const legacyLineItemElements = lineItemElements.filter(item => {
    const orderSystem = item.getAttribute('data-order-system');
    return orderSystem === 'LEGACY';
  });
  return legacyLineItemElements;
}

function addUpsellKeysToLegacyEditUrls() {
  const baseUrl = window.location.origin;
  const legacyLineItemElements = getAllParentLegacyLineItemElements();
  legacyLineItemElements.forEach(legacyLineItemElement => {
    const editLinks = legacyLineItemElement.querySelectorAll(
      '.edit-selection-link'
    );

    const upsellKeys = getChildLineItemKeys(legacyLineItemElement);

    editLinks.forEach(editLink => {
      const href = editLink.getAttribute('href');
      const url = new URL(href, baseUrl);
      upsellKeys.forEach(key => url.searchParams.append('upsell', key));
      editLink.setAttribute('href', url.toString());
    });
  });
}
